import { useMutationBuilder, useQueryBuilder } from "../useBuilders";
import { FETCH, UPDATE, NOTIFICATION } from "../queryKeys";
import { notificationsApi } from "src/services/settings/notifications";

export const useNotificationsFetch = () => {
  return useQueryBuilder([NOTIFICATION, FETCH], notificationsApi.fetchNotification);
};

export const useNotificationsUpdate = () => {
  return useMutationBuilder([NOTIFICATION, UPDATE], notificationsApi.updateNotification, [NOTIFICATION, FETCH]);
}
